import React from 'react';
import { useTranslate } from '../../../../../customHooks';
import { formatChangeProtection, getFirewallName, getFirewallStateDisplay, renderStatusWithCommit } from '../../../firewallsUtil';
import { TruncateText } from '@panwds/react-ui';

interface GeneralInfoProps {
    firewall: any;
    status: any;
    styles: any;
}

const GeneralInfoOverview: React.FC<GeneralInfoProps> = ({ firewall, status, styles }) => {
    const translate = useTranslate();

    return (
        <div className={styles.flexContainer}>
            <h2 className={styles.title}>{translate(`resources.firewallsV2.generalInfo`)}</h2>
            <div className={styles.flexColumn}>
                <div className={styles.flexRow}>
                    <strong className={styles.flexRowHeader}>{translate(`resources.firewallsV2.firewallId`)}</strong>
                    <span className={styles.flexRowValues}><TruncateText>{firewall?.FirewallId}</TruncateText></span>
                </div>
                <div className={styles.flexRow}>
                    <strong className={styles.flexRowHeader}>{translate(`resources.firewallsV2.firewallStatus`)}</strong>
                    <span className={styles.flexRowValues}>{getFirewallStateDisplay(status)}</span>
                </div>
                <div className={styles.flexRow}>
                    <strong className={styles.flexRowHeader}>{translate(`resources.firewallsV2.firewallCommitStatus`)}</strong>
                    <span className={styles.flexRowValues}>
                        {renderStatusWithCommit(status?.DeviceRuleStackCommitStatus, status?.DeviceRuleStackCommitInfo)}
                    </span>
                </div>
                <div className={styles.flexRow}>
                    <strong className={styles.flexRowHeader}>{translate(`resources.firewallsV2.firewallName`)}</strong>
                    <span className={styles.flexRowValues}><TruncateText>{getFirewallName(firewall)}</TruncateText></span>
                </div>
                <div className={styles.flexRow}>
                    <strong className={styles.flexRowHeader}>{translate(`resources.firewallsV2.dpAccountId`)}</strong>
                    <span className={styles.flexRowValues}><TruncateText>{firewall?.DeploymentAccountId}</TruncateText></span>
                </div>
                <div className={styles.flexRow}>
                    <strong className={styles.flexRowHeader}>{translate(`resources.firewallsV2.region`)}</strong>
                    <span className={styles.flexRowValues}>{firewall?.Region}</span>
                </div>
                <div className={styles.flexRow}>
                    <strong className={styles.flexRowHeader}>{translate(`resources.firewallsV2.availabilityZoneIDs`)}</strong>
                    <span className={styles.flexRowValues}><TruncateText>{firewall?.CustomerZoneIdList?.join(', ')}</TruncateText></span>
                </div>
                <div className={styles.flexRow}>
                    <strong className={styles.flexRowHeader}>{translate(`resources.firewallsV2.changeProtection`)}</strong>
                    <span className={styles.flexRowValues}>
                        {firewall?.ChangeProtection ? formatChangeProtection(firewall.ChangeProtection) : '-'}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default GeneralInfoOverview;
